import BasicRepository from "./basicRepository";
import Client from "../client";
import {
    AccountResource,
    AccountUsageResource,
    AzureEnvironment,
    AccountType,
    AzureWebSite,
    AzureWebSiteSlot
} from "../resources";

interface AccountRepositoryListArgs {
    skip?: number;
    take?: number;
    orderBy?: string;
    accountType?: AccountType[];
}

class AccountRepository extends BasicRepository<AccountResource, AccountResource, AccountRepositoryListArgs> {
    constructor(client: Client) {
        super("Accounts", client);
    }
    getWebSites(account: AccountResource): Promise<AzureWebSite[]> {
        return this.client.get(account.Links["WebSites"]);
    }
    getWebSiteSlots(account: AccountResource, resourceGroupName: string, webSiteName: string): Promise<AzureWebSiteSlot[]> {
        const args: {resourceGroupName: string, webSiteName: string } = { resourceGroupName, webSiteName};
        return this.client.get(account.Links["WebSiteSlots"], args);
    }
    getCloudServices(account: AccountResource) {
        return this.client.get(account.Links["CloudServices"]);
    }
    getStorageAccounts(account: AccountResource) {
        return this.client.get(account.Links["StorageAccounts"]);
    }
    getResourceGroups(account: AccountResource) {
        return this.client.get(account.Links["ResourceGroups"]);
    }
    getFabricApplications(account: AccountResource) {
        return this.client.get(account.Links["FabricApplications"]);
    }
    getAccountUsages(account: AccountResource): Promise<AccountUsageResource> {
        return this.client.get(account.Links["Usages"]);
    }
    getIsolatedAzureEnvironments(): Promise<AzureEnvironment[]> {
        return this.client.get(this.client.getRootDocument().Links["Accounts"].concat("/azureenvironments"));
    }
}

export default AccountRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/accountRepository.ts